import { render } from "./RiSupport.vue?vue&type=template&id=66f2bbdc"
import script from "./RiSupport.vue?vue&type=script&lang=js"
export * from "./RiSupport.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiSupport.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "66f2bbdc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('66f2bbdc', __exports__)) {
    api.reload('66f2bbdc', __exports__)
  }
  
  module.hot.accept("./RiSupport.vue?vue&type=template&id=66f2bbdc", () => {
    api.rerender('66f2bbdc', render)
  })

}


export default __exports__